<template>
  <VModal :showing="showing" overflow-content container-classes="w-192" @update:showing="cancel">
    <div class="flex items-start">
      <span class="flex-shrink-0 w-10 h-10 mr-4 rounded-full bg-gold-100 grid place-items-center">
        <ExclamationTriangleIcon class="inline h-6 text-gold-50" />
      </span>
      <div>
        <h2 class="mb-4 mr-6 text-xl">Warning - 3D Presentation contains confidential drill data</h2>
        <div class="font-light text-gray-700 space-y-4" data-testid="drill-label-access-warning-subtitle">
          <p>This 3D Presentation is currently using the following drill data sets which are marked confidential:</p>

          <ul class="pl-5">
            <li v-for="drill in drillData.slice(0, 5)" :key="drill.id" class="list-disc" data-testid="drill-label-access-warning-list">
              <div class="truncate">{{ drill.name }}</div>
            </li>
            <li v-if="drillData.length > 5" class="mt-2 list-none">
              <em>&hellip;{{ drillData.length - 5 }} more&hellip;</em>
            </li>
          </ul>
          <p>
            Turning this 3D Presentation public while keeping your drill data confidential will result in visitors not being able to view the drill
            data above
          </p>
        </div>

        <div class="flex flex-row justify-end w-full mt-8 gap-4">
          <VButton data-testid="drill-label-access-warning-cancel" size="sm" @click="secondaryAction"
            >Make 3D Presentation public and hide drill data</VButton
          >
          <VButton variant="dark" data-testid="drill-label-access-warning-confirm" size="sm" @click="confirm">
            Make 3D Presentation and drill data public
          </VButton>
        </div>
      </div>
    </div>
  </VModal>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import { ref, computed } from 'vue'
import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline'

import type { Drill } from '~/entities/drill'

const props = defineProps({
  showing: {
    type: Boolean,
    default: false,
  },
  drillData: {
    type: Array as PropType<Drill[]>,
    required: true,
  },
})

const emit = defineEmits(['confirm', 'cancel', 'secondary-action'])

function cancel() {
  emit('cancel')
}

function secondaryAction() {
  emit('secondary-action')
}

function confirm() {
  emit('confirm', props.drillData)
}
</script>
